import {useEffect, useLayoutEffect} from 'react';

export const useIsomorphicLayoutEffect = 'undefined' !== typeof window ? useLayoutEffect : useEffect;
